/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SectorNodeGuidsBackfillResultDto } from '../models/SectorNodeGuidsBackfillResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SectorNodeGuidsBackfillService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns SectorNodeGuidsBackfillResultDto OK
     * @throws ApiError
     */
    public postApiHousingSectorNodeGuidsBackfillPreviewBackfill(): CancelablePromise<SectorNodeGuidsBackfillResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/SectorNodeGuidsBackfill/PreviewBackfill',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns SectorNodeGuidsBackfillResultDto OK
     * @throws ApiError
     */
    public postApiHousingSectorNodeGuidsBackfillExecuteBackfill(): CancelablePromise<SectorNodeGuidsBackfillResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/SectorNodeGuidsBackfill/ExecuteBackfill',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
